import * as React from 'react';
import { AutoCompleteAsync } from 'sha-el-design';
import Api from 'requestapijs';
import { Omit } from 'sha-el-design/lib/helpers';
import { StateNodeConnection, StateNodeEdge } from '../../../schema';
import { stateDropdownQuery } from './constants';
import { API_URL, HEADER } from '../../config';
import { AutoCompleteAsyncProps } from 'sha-el-design/lib/components/AutoComplete/AutoCompleteAsync';

export class MultipleStateDropdown extends React.Component<Props, State> {
  static defaultProps = {
    extrafields: [],
  };

  constructor(props) {
    super(props);

    this.state = {
      name: '',
    };
  }

  fetch = (name: string) =>
    new Promise<StateNodeEdge[]>((resolve, reject) => {
      Api.graphql<{ name: string }, { data: { allStates: StateNodeConnection } }>(
        API_URL,
        { name },
        stateDropdownQuery,
        HEADER,
        (v) => resolve(v.data.allStates.edges),
        (e) => reject(e),
      );
    })

  render() {
    const { name } = this.state;
    const { value: id } = this.props;
    return (
      <AutoCompleteAsync<StateNodeEdge>
        {...this.props}
        mode='multiple'
        data={(v) => this.fetch(v)}
        inputProps={{
          ...this.props.inputProps,
        }}
        filterFunction={() => true}
      />
    );
  }
}

interface Props extends Omit<AutoCompleteAsyncProps<StateNodeEdge>, 'data'> {
  mode: 'multiple';
  value: StateNodeEdge[];
  onChange: (value: StateNodeEdge[]) => void;
}

interface State {
  name: string;
}
